export default __webpack_public_path__ + "static/media/diagram-mobile.30888798.svg";